var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed inset-x-0 z-50"},[_c(_vm.component,{tag:"component",attrs:{"menu":_vm.menu,"phone":_vm.phone},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_vm._t("logo")]},proxy:true},{key:"icons",fn:function(){return [_vm._t("icons")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }